export default "__VITE_ASSET__B6rY0t6b__"